import { Component, OnInit } from '@angular/core';
import { StateService } from '@uirouter/angular';
import { NgbModal, ModalDismissReasons, NgbModalRef } from '@ng-bootstrap/ng-bootstrap'
import { ApiService } from '../../services/api.service';
import { FrontEndService } from '../../services/front-end.service';
import { DataService } from '../../services/data.service';
import { LogService } from '../../services/log.service';

@Component({
  selector: 'app-userprofile',
  templateUrl: './userprofile.component.html',
  styleUrls: ['./userprofile.component.scss']
})
export class UserprofileComponent implements OnInit {
  loading = false;
  showCaps = false;

  constructor(
    private modalService: NgbModal,
    private stateService: StateService,
    private apiService: ApiService,
    private frontEndService: FrontEndService,
    public dataService: DataService,
    private logService: LogService
  ) { }

  ngOnInit() {
    this.dataService.getUserprofiledata();
  }

  capsLock(e) {
    const kc = e.keyCode ? e.keyCode : e.which;
    const sk = e.shiftKey ? e.shiftKey : (kc === 16);
    if (((kc >= 65 && kc <= 90) && !sk) || ((kc >= 97 && kc <= 122) && sk)) {
      this.showCaps = true;
    } else {
      this.showCaps = false;
    }
  }

  showPassword = (input: any): any => {

    // this.logService.printLog("check ", input.nextSibling.nextSibling.classList)
    const picon = document.querySelector('.picon');

    if (input.nextSibling.nextSibling.classList.contains('fa-eye-slash')) {
      input.type = input.type === 'password' ? 'text' : 'text';
      input.nextSibling.nextSibling.classList.add('fa-eye');
      input.nextSibling.nextSibling.classList.remove('fa-eye-slash');
    } else {
      input.type = input.type === 'password' ? 'text' : 'password';
      input.nextSibling.nextSibling.classList.remove('fa-eye');
      input.nextSibling.nextSibling.classList.add('fa-eye-slash');
    }
  };

  updateuser(data) {
    let userObject = {};
    userObject['user_id'] = this.dataService.userDetails['user_id'];
    if (this.dataService.userForm["email"] !==  this.dataService.oldEmail) {
      this.dataService.userDetails['profile'].emailVerified = false;
      this.dataService.userForm["emailVerified"] = false;
      userObject['emailVerified'] = false;
    }
    if (this.dataService.userForm["phone_number"] !==  this.dataService.oldPhoneNumber || !this.dataService.userDetails['profile']['mobileVerified']) {
      this.dataService.userDetails['profile'].mobileVerified = false;
      this.dataService.userForm["mobileVerified"] = false;
      userObject['mobileVerified'] = false;
    }
    this.dataService.userForm['country'] = this.dataService.selectedCountryName;
    this.dataService.userForm['country_code'] = this.dataService.selectCountryDial.substring(1);

    if (this.dataService.userForm['email'] !== null && this.dataService.userForm["email"] !==  this.dataService.oldEmail) {
      userObject['email'] = this.dataService.userForm["email"];
    }
    if(this.dataService.userForm['country'] !== null) {
      userObject['country'] = this.dataService.userForm["country"];
    }
    if(this.dataService.userForm['country_code'] !== null) {
      userObject['country_code'] = this.dataService.userForm["country_code"];
    }
    if(this.dataService.userForm['phone_number'] !== null) {
      userObject['phone_number'] = this.dataService.userForm["phone_number"];
    }
    if(this.dataService.userForm['password'] !== null) {
      userObject['password'] = this.dataService.userForm['password'];
    }
    if(this.dataService.userForm['old_password'] !== null) {
      userObject['old_password'] = this.dataService.userForm['old_password'];
    }
    if (this.dataService.userForm['first_name'] !== null) {
      userObject['first_name'] = this.dataService.userForm['first_name'];
    }
    if (this.dataService.userForm['last_name'] !== null) {
      userObject['last_name'] = this.dataService.userForm['last_name'];
    }
    if (this.dataService.userForm['age'] !== null) {
      userObject['age'] = this.dataService.userForm['age'];
    }
    if (this.dataService.userForm['town'] !== null) {
      userObject['town'] = this.dataService.userForm['town'];
    }
    if (this.dataService.userForm['gender'] !== null) {
      userObject['gender'] = this.dataService.userForm['gender'];
    }
    // this.logService.printLog("userObject", userObject);
    if((userObject['old_password'] == null || userObject['old_password'] == "") && (userObject['password'] == null || userObject['password'] == "")) {
      delete userObject['old_password'];
      delete userObject['password'];
      this.userUpdate(userObject);
    } else if( (userObject['old_password'] == null || userObject['old_password'] == "")  || (userObject['password'] == null || userObject['password'] == "") ){
      this.frontEndService.addToast("Error", "Both password field can't be empty", "error");
    } 
    else {
      this.userUpdate(userObject);
    }
    

  }
  userUpdate(userObj){
    this.apiService.updateProfile(userObj, (response) => {
      // this.logService.printLog("User update response - ", response);
      if (response['response'] === 'ok') {
        this.dataService.setProfile();
        this.dataService.getUserprofiledata();
        this.frontEndService.addToast("Success", response['message'], "success");
      } else {
        this.frontEndService.addToast("Error", response['message'], "error");
      }
    });
  }


  emailOtpDtata() {
    this.dataService.isEmail = true;
    this.dataService.otpData['send_to'] = 'email';
    this.dataService.otpData['user_id'] = this.dataService.userForm['user_id'];
    this.dataService.otpData['to'] = this.dataService.userForm['email'];
    this.loading = true;
    this.apiService.sendEmailOtp(this.dataService.otpData, (response) => {
      this.loading = false;
      this.dataService.otpSendEmail = response.otp;
      // this.logService.printLog("Email otp -", this.dataService.otpSendEmail);
    });
  }

  phoneOtpData() {
    this.dataService.isEmail = false;
    this.dataService.otpData['send_to'] = 'sms';
    this.dataService.otpData['user_id'] = this.dataService.userForm['user_id'];
    this.dataService.otpData['to'] = this.dataService.userForm['phone_number'];
    this.dataService.otpData['country_code'] = this.dataService.selectCountryDial.split("+")[1];
    // this.logService.printLog("user profile", this.dataService.userForm);
    this.loading = true;
    this.apiService.sendPhoneOtp(this.dataService.otpData, (response) => {
      this.loading = false;
      this.dataService.otpSendPhone = response.otp;
      this.logService.printLog("Phone otp -", this.dataService.otpSendPhone);
    });
  }

}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/landing_page/src/app/components/userprofile/userprofile.component.ts